import { formatBankAccount, formatIBAN } from "@edaz/utils/bankAccount";
import React from "react";
import { IconType } from "@edaz/edazkit/Icon";
import { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import BankTransferViewModel from "../../../viewModels/common/payment/bankTransferViewModel";
import Collapsible from "../collapsible/collapsible";
import { ta } from "date-fns/locale";
import { Row, Col } from "react-bootstrap";
import styles from "./bankTransfer.module.scss";

const SepaInstructions: ViewComponent<BankTransferViewModel> = observer(({ vm }) => {
  const ta = (attribute: string, model?: string) => vm.localizationService.translateAttribute(model || "payment", attribute);

  const [collapsed, setCollapse] = useState(true);

  const toggle = () => {
    setCollapse(!collapsed);
  };

  function translateLabel(code: string) {
    return vm.translate(`sepaInstructions.labels.${code}`);
  }

  const QRCodeImage: React.FC<{ base64Svg: string }> = ({ base64Svg }) => {
    const svgXml = atob(base64Svg);
    return <div className={styles.qrCodeContainer} dangerouslySetInnerHTML={{ __html: svgXml }} />;
  };
  return (
    <Row className="position-relative">
      <Col xs={6}>
        <Row className="mb-3">
          <Col>
            <span className="font-weight-bold">{translateLabel("iban")}</span>
            <div style={{ wordBreak: "break-all", wordWrap: "break-word" }}>
              <span className={styles.disableLinkTel}>{vm.iban ? formatIBAN(vm.iban) : "-"}</span>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <span className="font-weight-bold">{translateLabel("swift")}</span>
            <div className="text-nowrap">
              <span className={styles.disableLinkTel}>{vm.swiftCode || "-"}</span>
            </div>
          </Col>
        </Row>
      </Col>
      <Col xs={12}>
        <Row className="mb-3">
          <Col>
            <span className="font-weight-bold">{translateLabel("name")}</span>
            <div style={{ wordWrap: "break-word" }}>
              <span className={styles.disableLinkTel}>{vm.counterpartyName || "-"}</span>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <span className="font-weight-bold">{ta("messageForRecipient")}</span>
            <div className="text-wrap">
              <span className={styles.disableLinkTel}>{vm.additionalInformation || "-"}</span>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <span className="font-weight-bold">{translateLabel("additionalInformation")}</span>
            <div className="text-nowrap">
              <span className={styles.disableLinkTel}>{vm.additionalInformation || "-"}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <span className="font-weight-bold">{translateLabel("amount")}</span>
            <div className="text-nowrap">{vm.priceSepa || "-"}</div>
          </Col>
        </Row>
      </Col>
      {vm.qrcode && (
        <div className={`${styles.qrCodeFixed} ${styles.qrCodeContainer} pl-3`}>
          <QRCodeImage base64Svg={vm.qrcode} />
        </div>
      )}
    </Row>
  );
});

export default SepaInstructions;
